import { ReactElement } from 'react'
import { useParams } from 'react-router-dom'
import { Chip } from '@mui/material'
import useUIStore from 'src/state/stores/ui'

/**
 * How many elements the agent marked in the scene (`mark_elements`), with an
 * x that removes the marking. Shown only while something is marked.
 */
const MarkedElementsChip = (): ReactElement | null => {
  const { projectId } = useParams()
  const count = useUIStore(state =>
    projectId ? state.aiChatMarkedElementGuidsByProject[projectId]?.length ?? 0 : 0,
  )
  const setAiChatMarkedElementGuids = useUIStore(state => state.setAiChatMarkedElementGuids)

  if (!projectId || count === 0) return null

  return (
    <Chip
      size="small"
      color="primary"
      variant="outlined"
      label={count === 1 ? '1 Element markiert' : `${count} Elemente markiert`}
      onDelete={() => setAiChatMarkedElementGuids(projectId, [])}
      sx={{ alignSelf: 'flex-start', mb: 1 }}
      data-cy="ai-chat-marked-elements"
    />
  )
}

export default MarkedElementsChip
